import CookieService from "./cookieService";
export const logout = () => {
  const cookieService = CookieService.getService();
  cookieService.clearToken();
  sessionStorage.clear();
};
